module.exports = __webpack_public_path__ + "img/back-icon.5d5faab6.svg";